import { Tip } from '~/components/ui/tip';

interface Props {
  className?: string;
  /** Compact variant: smaller logo + text, suitable for sidebars/footers. */
  compact?: boolean;
}

export function PoweredByBlockbrain({ className = '', compact = false }: Props) {
  const size = compact ? 14 : 18;

  return (
    <Tip label="Powered by Blockbrain">
      <a
        href="https://theblockbrain.ai"
        target="_blank"
        rel="noreferrer"
        className={`flex items-center justify-center gap-1.5 text-muted-foreground/70 hover:text-foreground transition-colors ${className}`}
      >
        <span className={compact ? 'text-[length:var(--text-2xs)]' : 'text-xs'}>Powered by</span>
        <img
          src="/blockbrain-logo-dark.png"
          alt="Blockbrain"
          width={size}
          height={size}
          className="dark:invert"
        />
        <span className={compact ? 'text-[length:var(--text-2xs)] font-medium' : 'text-xs font-medium'}>Blockbrain</span>
      </a>
    </Tip>
  );
}
